import React from 'react';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/reviews';
export function Reviews() {
  return <section id="reviews" aria-labelledby="reviews-heading" className="w-full scroll-mt-36 bg-kosin-mist" data-id="element-276" data-mp="2hddo1lbcew3k">
      <div className="mx-auto max-w-shell px-[18px] py-12 sm:px-6 lg:py-20" data-id="element-277" data-mp="2ma4448n5droz">
        <h2 id="reviews-heading" className="text-[28px] font-bold leading-tight text-kosin-charcoal lg:text-[36px]" data-id="element-278" data-mp="2rbth3ttxkffp">
          What Customers Tell Us
        </h2>

        <ul className="mt-9 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:mt-12 lg:grid-cols-4" data-id="element-279" data-mp="30aolr1hbthgw">
          {reviews.map(review => <li key={review.name} className="flex h-full min-w-0 flex-col" data-id="element-280" data-mp="352q7de0dwkjl">
              <div className="flex items-center gap-1" aria-hidden="true" data-id="element-281" data-mp="3a0884h48ztgi">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-[15px] w-[15px] fill-kosin-red text-kosin-red" data-id="element-282" data-mp="3f27bvs3wgsdz" />)}
              </div>
              <span className="sr-only" data-id="element-283" data-mp="2re8k758da7l7">5-star review</span>
              <blockquote className="mt-4 text-[17px] leading-relaxed text-kosin-ink" data-id="element-284" data-mp="2md1cf66858ej">
                “{review.quote}”
              </blockquote>
              <div className="mt-auto pt-5" data-id="element-285" data-mp="2herit005efv1">
                <p className="text-[15px] font-semibold text-kosin-charcoal" data-id="element-286" data-mp="2ddeamj9l20ky">
                  {review.name}
                </p>
                <a href={review.sourceUrl} target="_blank" rel="noopener noreferrer" aria-label={`Read ${review.name}'s full Google review (opens in a new tab)`} className="inline-flex min-h-11 items-center text-[14px] text-kosin-body underline decoration-kosin-line underline-offset-4 transition-colors hover:text-kosin-red focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-kosin-red" data-id="element-287" data-mp="3a1u1ciofifzn">
                  Read Full Google Review
                </a>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}